import React from 'react';
import { PMenuIconProps, useMenuIcon } from './useMenuIcon';

export const HomeIco: React.FC<PMenuIconProps> = (props) => {
  const { currentColor, classes } = useMenuIcon(props);
  return (
    <svg
      className={classes.ico}
      width="30"
      height="24"
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9994 4.88184L4.30002 13.7023C4.30002 13.7148 4.29689 13.7331 4.29064 13.7581C4.28451 13.7828 4.28125 13.8008 4.28125 13.8136V22.7453C4.28125 23.0678 4.39915 23.3472 4.63489 23.5826C4.87056 23.8181 5.14964 23.9366 5.4722 23.9366H12.6174V16.791H17.3815V23.9368H24.5266C24.849 23.9368 25.1285 23.8186 25.3639 23.5826C25.5996 23.3475 25.7179 23.0678 25.7179 22.7453V13.8136C25.7179 13.7641 25.7111 13.7266 25.6991 13.7023L14.9994 4.88184Z"
        fill={currentColor}
      />
      <path
        d="M29.793 11.6926L25.7182 8.306V0.713927C25.7182 0.540365 25.6624 0.397631 25.5504 0.285921C25.4393 0.174341 25.2966 0.118551 25.1227 0.118551H21.55C21.3763 0.118551 21.2336 0.174341 21.1218 0.285921C21.0103 0.397631 20.9546 0.54043 20.9546 0.713927V4.34243L16.4143 0.546296C16.0178 0.223744 15.5463 0.0625 15.0004 0.0625C14.4546 0.0625 13.9832 0.223744 13.5863 0.546296L0.206772 11.6926C0.0827436 11.7917 0.0147659 11.9251 0.00212194 12.0926C-0.0104569 12.2599 0.0328846 12.4061 0.132277 12.5301L1.28594 13.9071C1.38533 14.0187 1.51542 14.0869 1.67673 14.1119C1.82566 14.1244 1.97458 14.0809 2.12351 13.9817L15 3.24455L27.8767 13.9816C27.9762 14.0681 28.1062 14.1114 28.2675 14.1114H28.3234C28.4845 14.0869 28.6143 14.0182 28.7142 13.9068L29.868 12.53C29.9672 12.4058 30.0107 12.2599 29.9978 12.0923C29.985 11.9253 29.9168 11.7919 29.793 11.6926Z"
        fill={currentColor}
      />
    </svg>
  );
};
